import React, { useState, useEffect, useRef } from 'react';
import { WebsiteImage } from 'components/TitleDescription';

const AdSection = ({ adData, ...otherProps }) => {
  return (
    <div className="invoice-gen--ad-container">
      <div className="invoice-gen--ad-content">
        {adData?.image?.image && (
          <>
            <WebsiteImage src={adData?.image?.image?.fluid.src} alt={adData?.image.alt} />
            {adData?.url && <a href={adData?.url} target="_blank" />}
          </>
        )}
      </div>
    </div>
  );
};

export default AdSection;
